var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlackIcon = function SvgBlackIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    fillRule: "evenodd",
    d: "M10 3.333c.46 0 .833.373.833.834v11.666a.833.833 0 0 1-1.667 0V4.167c0-.46.374-.834.834-.834",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    fillRule: "evenodd",
    d: "M3.334 10c0-.46.373-.833.833-.833h11.667a.833.833 0 0 1 0 1.666H4.167A.833.833 0 0 1 3.334 10",
    clipRule: "evenodd"
  })));
};
export default SvgBlackIcon;